/**
 * HC Custom Cart Functionality - Vanilla JS
 * Converted from jQuery - 2026-01-23
 *
 * Features:
 * - Add to cart via .hc-atc buttons
 * - Button animation on click
 * - Variant selector updates
 * - Quantity increment/decrement controls
 */

(function() {
  'use strict';

  // ========================================================================
  // Add to Cart Handler
  // ========================================================================

  function getAtcErrorContainer(button) {
    if (!button) {
      return null;
    }
    return button.closest('.hc-atc-form') || button.parentElement;
  }

  function clearAtcError(button) {
    var container = getAtcErrorContainer(button);
    if (!container) {
      return;
    }
    var existing = container.querySelector('.hc-atc-error');
    if (existing) {
      existing.remove();
    }
  }

  function showAtcError(button, message) {
    if (!message) {
      return;
    }

    var container = getAtcErrorContainer(button);
    if (!container) {
      return;
    }

    clearAtcError(button);

    var errorDiv = document.createElement('div');
    errorDiv.className = 'errors text-center hc-atc-error';
    errorDiv.textContent = message;
    container.appendChild(errorDiv);

    setTimeout(function() {
      if (errorDiv && errorDiv.parentNode) {
        errorDiv.parentNode.removeChild(errorDiv);
      }
    }, 4000);
  }

  function normalizeCartError(message) {
    if (window.theme && theme.utils && theme.utils.normalizeCartError) {
      return theme.utils.normalizeCartError(message);
    }
    if (!message) return null;
    if (message.indexOf('All 0') !== -1) {
      return 'The item is out of stock!';
    }
    return message;
  }

  function parseProductTags(button) {
    var encodedTags = button.getAttribute('data-product-tags');
    if (!encodedTags) return null;

    try {
      if (window.IBAccessPolicy && typeof window.IBAccessPolicy.parseTags === 'function') {
        var parsedTags = window.IBAccessPolicy.parseTags(encodedTags);
        if (!parsedTags) throw new Error('No product tags parsed');
        return parsedTags;
      }
      return JSON.parse(decodeURIComponent(encodedTags.replace(/\+/g, '%20')));
    } catch (error) {
      console.warn('Unable to parse product restriction tags for ATC button', error);
      return null;
    }
  }

  function getRestrictionMessage(access) {
    return access && (access.message || access.restriction_message) || 'Contact us for information';
  }

  function buttonCanAddToCart(button) {
    var tags = parseProductTags(button);
    var fallbackMessage = button.getAttribute('data-access-message') || 'Contact us for information';
    if (!tags) {
      return {
        allowed: true,
        message: fallbackMessage
      };
    }

    // HC - The button's variant SKUs too, for the brand rule - 2026-09-30
    var product = { tags: tags, skus: button.getAttribute('data-product-skus') || [] };
    var access;
    if (window.IBAccessPolicy && typeof window.IBAccessPolicy.evaluateProductAccess === 'function') {
      access = window.IBAccessPolicy.evaluateProductAccess(product);
    } else if (typeof window.calculateProductRestrictions === 'function') {
      access = window.calculateProductRestrictions(product);
    } else {
      return {
        allowed: true,
        message: fallbackMessage
      };
    }

    return {
      allowed: access.canAddToCart !== false && access.hideprice !== true,
      message: getRestrictionMessage(access) || fallbackMessage
    };
  }

  async function handleAddToCart(button) {
    const variantId = button.getAttribute('data-id');
    const quantity = button.getAttribute('data-qty') || '1';

    if (!variantId) {
      console.error('Missing variant ID on .hc-atc button');
      return;
    }

    var accessCheck = buttonCanAddToCart(button);
    if (!accessCheck.allowed) {
      showAtcError(button, accessCheck.message);
      return;
    }

    // Block add-to-cart for sold-out variants
    if (button.hasAttribute('disabled')) {
      showAtcError(button, 'This item is currently sold out.');
      return;
    }

    var quantityNumber = parseInt(quantity, 10) || 1;

    try {
      clearAtcError(button);

      // Silent add: keep the drawer closed and confirm with the shared cart
      // toast, matching the collection-grid ATC behavior.
      const result = await theme.cart.addSilently([{
        id: variantId,
        quantity: quantityNumber
      }], {
        source: 'hc-custom-atc'
      });

      if (result.raw && (result.raw.status === 422 || result.raw.status === 'bad_request')) {
        var message = normalizeCartError(result.raw.description || result.raw.message) ||
          'Unable to add item to cart. Please try again.';
        showAtcError(button, message);
        return;
      }

      var addedItems = Array.isArray(result.addedItems) ? result.addedItems : [];
      showAddedToast(addedItems[0] || null, quantityNumber);

    } catch (err) {
      console.error('Add to cart failed:', err);
      showAtcError(button, (err && err.userMessage) || 'Unable to add item to cart. Please try again.');
    }
  }

  // ========================================================================
  // Added-to-cart Toast (shares .cg-toast styles from hc-custom.css)
  // ========================================================================

  function getToastContainer() {
    var container = document.body.querySelector(':scope > .cg-toast-container');
    if (!container) {
      container = document.createElement('div');
      container.className = 'cg-toast-container';
      container.setAttribute('popover', 'manual');
      document.body.appendChild(container);
    }
    try {
      if (!container.matches(':popover-open')) {
        container.showPopover();
      }
    } catch (e) {}
    return container;
  }

  function showAddedToast(addedItem, quantity) {
    var container = getToastContainer();
    var toast = document.createElement('div');
    toast.className = 'cg-toast';

    var image = addedItem && (addedItem.image ||
      (addedItem.featured_image && addedItem.featured_image.url));
    if (image) {
      var img = document.createElement('img');
      img.src = image;
      img.alt = '';
      img.className = 'cg-toast__image';
      toast.appendChild(img);
    }

    var textWrap = document.createElement('div');
    textWrap.className = 'cg-toast__text';

    var line1 = document.createElement('div');
    line1.className = 'cg-toast__line';
    line1.textContent = 'Added to cart';
    textWrap.appendChild(line1);

    var title = addedItem && (addedItem.product_title || addedItem.title);
    var line2Text = ((quantity ? quantity + ' × ' : '') + (title || '')).trim();
    if (line2Text) {
      var line2 = document.createElement('div');
      line2.className = 'cg-toast__line cg-toast__line--meta';
      line2.textContent = line2Text;
      textWrap.appendChild(line2);
    }

    toast.appendChild(textWrap);
    container.appendChild(toast);

    requestAnimationFrame(function() {
      toast.classList.add('is-visible');
    });

    setTimeout(function() {
      toast.classList.remove('is-visible');
      setTimeout(function() {
        toast.remove();
        if (!container.hasChildNodes()) {
          try { container.hidePopover(); } catch (e) {}
          container.remove();
        }
      }, 300);
    }, 2500);
  }

  // ========================================================================
  // Button Animation Handler
  // ========================================================================

  function animateButton(button) {
    button.classList.add('hc-dot-acive'); // Note: original typo preserved for CSS compatibility

    setTimeout(function() {
      button.classList.remove('hc-dot-acive');
    }, 800);
  }

  // ========================================================================
  // Variant Selector Handler
  // ========================================================================

  function handleVariantChange(select) {
    const productId = select.getAttribute('data-product');
    const selectedValue = select.value;
    const selectedOption = select.options[select.selectedIndex];
    const priceHtml = selectedOption ? selectedOption.getAttribute('data-price') : null;

    if (!productId) {
      console.error('Missing data-product attribute on .hc-select');
      return;
    }

    // Update the corresponding ATC button's variant ID
    const atcButton = document.querySelector('.hc-atc[data-product="' + productId + '"]');
    if (atcButton) {
      atcButton.setAttribute('data-id', selectedValue);
    }

    // Read inventory data from the selected option
    var selectedOpt = select.options[select.selectedIndex];
    if (selectedOpt && atcButton) {
      var variantAvailable = selectedOpt.getAttribute('data-available') !== 'false';
      var invMgmt = selectedOpt.getAttribute('data-inventory-management');
      var invPolicy = selectedOpt.getAttribute('data-inventory-policy');
      var invQty = selectedOpt.getAttribute('data-inventory-quantity');

      // Update ATC button state based on availability
      var atcText = atcButton.querySelector('.hc-atc-text');
      if (variantAvailable) {
        atcButton.removeAttribute('disabled');
        if (atcText) atcText.textContent = 'Add to Cart';
      } else {
        atcButton.setAttribute('disabled', 'disabled');
        if (atcText) atcText.textContent = 'Sold Out';
      }

      // Update max quantity on the quantity input
      var qtyInput = document.querySelector('.js-quantity-selector[data-product="' + productId + '"]');
      if (qtyInput) {
        var maxQty = '';
        if (invMgmt === 'shopify' && invPolicy === 'deny' && invQty !== '' && invQty !== null) {
          maxQty = parseInt(invQty, 10);
        }
        qtyInput.setAttribute('data-max-qty', maxQty);

        // Clamp current quantity if it exceeds new max
        if (maxQty !== '' && parseInt(qtyInput.value, 10) > maxQty) {
          qtyInput.value = Math.max(1, maxQty);
          atcButton.setAttribute('data-qty', qtyInput.value);
        }
      }
    }

    // If this is a carousel select, update the displayed price
    if (select.classList.contains('hc-carousel-select') && priceHtml) {
      const priceElement = document.querySelector('.grid-product__price[data-product="' + productId + '"]');
      if (priceElement) {
        priceElement.innerHTML = priceHtml;
      }
    }
  }

  // ========================================================================
  // Quantity Control Handlers
  // ========================================================================

  function handleQuantityChange(button, increment) {
    const productId = button.getAttribute('data-product');

    if (!productId) {
      console.error('Missing data-product attribute on quantity button');
      return false;
    }

    const input = document.querySelector('.js-quantity-selector[data-product="' + productId + '"]');
    if (!input) {
      console.error('Quantity input not found for product: ' + productId);
      return false;
    }

    const currentValue = parseInt(input.value, 10) || 0;
    var newValue = currentValue + increment;

    // Enforce minimum of 1
    if (newValue < 1) {
      newValue = 1;
    }

    // Enforce maximum based on available inventory
    var maxQty = input.getAttribute('data-max-qty');
    if (maxQty !== null && maxQty !== '') {
      var maxInt = parseInt(maxQty, 10);
      if (!isNaN(maxInt) && maxInt > 0 && newValue > maxInt) {
        newValue = maxInt;
      }
    }

    input.value = newValue;

    // Trigger change event for any listeners
    var changeEvent = new Event('change', { bubbles: true });
    input.dispatchEvent(changeEvent);

    // Update the corresponding ATC button's quantity
    const atcButton = document.querySelector('.hc-atc[data-product="' + productId + '"]');
    if (atcButton) {
      atcButton.setAttribute('data-qty', newValue);
    }

    return false; // Prevent default link behavior
  }

  // ========================================================================
  // Event Delegation Setup
  // ========================================================================

  document.addEventListener('click', function(e) {
    // Handle .hc-atc button clicks
    var atcButton = e.target.closest('.hc-atc');
    if (atcButton) {
      e.preventDefault();
      handleAddToCart(atcButton);
      animateButton(atcButton);
      return;
    }

    // Handle .qtyplus button clicks
    var plusButton = e.target.closest('.qtyplus');
    if (plusButton) {
      e.preventDefault();
      handleQuantityChange(plusButton, 1);
      return;
    }

    // Handle .qtyminus button clicks
    var minusButton = e.target.closest('.qtyminus');
    if (minusButton) {
      e.preventDefault();
      handleQuantityChange(minusButton, -1);
      return;
    }
  });

  // Handle .hc-select changes
  document.addEventListener('change', function(e) {
    var select = e.target.closest('.hc-select');
    if (select) {
      handleVariantChange(select);
    }
  });

})();
